import React, { useEffect } from 'react';
import Icon from 'screens/shared/icon';
import Popover from 'screens/shared/popover';
import {
  List, ListItem, ListItemText, ListItemAvatar, Avatar, ClickAwayListener,
} from '@mui/material';

import { actions } from 'redux/local';
import { useSelector } from 'react-redux';

export default ({ anchorEl, onClose, onClick }) => {
  const { templates = [] } = useSelector((e) => e);
  templates.sort((a, b) => (a.cores > b.cores ? 1 : -1));

  const listRender = (
    <ClickAwayListener onClickAway={onClose}>
      <List>
        {/* <ListItem key="help" className="cube-select-item">
          What is Cube
          <Icon name="question-circle" style={{ marginLeft: 5 }} />
        </ListItem> */}
        {templates.map(({ id = '', properties = {} }, i) => {
          const {
            name = '', cores = 0, ram = 0, storageSize = 0,
          } = properties;

          const description = `${cores} Cores, ${ram / 1024}GB RAM, ${storageSize}GB DAS`;

          return (
            <ListItem onClick={() => onClick(id)} key={name} className="cube-select-item">
              <ListItemAvatar>
                <Avatar style={{ background: `rgb(${200 - (40 * i)}, ${200 - (40 * i)}, ${200 - (40 * i)})` }}>
                  <Icon name="bolt" />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={name} secondary={description} />
            </ListItem>
          );
        })}
        {!templates.length && <ListItem>Cube templates are not available</ListItem>}
      </List>
    </ClickAwayListener>
  );

  useEffect(() => {
    if (anchorEl && !templates.length) {
      actions.template.getAll();
    }
    // eslint-disable-next-line
  }, [anchorEl]);


  return (
    <Popover
      anchorEl={anchorEl}
      render={listRender}
      onClose={onClose}
      isActionButtons={false}
      className="screen-create-server-cube"
    />
  );
};
